import {AxiosInstance, AxiosRequestConfig} from "axios";

export default class MerchantPartsApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Upload parts xlsx
	 * @param {File} file
	 */
	uploadGrahamParts(file: File) {
		const url = `/api/web/parts/stockist_parts/import`;
		const config: AxiosRequestConfig = {headers: {'content-type': 'multipart/form-data'}};
		const formData = new FormData();
		formData.append('file', file);
		return this.axiosInstance.post(url, formData, config)
	}
}